import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=e5377010&scoped=true&"
import script from "./VideoDetails.vue?vue&type=script&lang=js&"
export * from "./VideoDetails.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=e5377010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5377010",
  null
  
)

export default component.exports